"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMODALITIES = void 0;
var IMODALITIES;
(function (IMODALITIES) {
    IMODALITIES["Treadmill"] = "treadmill";
    IMODALITIES["Bike"] = "bike";
    IMODALITIES["Rower"] = "rower";
    IMODALITIES["Elliptical"] = "elliptical";
    IMODALITIES["Yoga"] = "yoga";
    IMODALITIES["Strength"] = "strength";
    IMODALITIES["Mind"] = "mind";
    IMODALITIES["Any"] = "any";
})(IMODALITIES || (exports.IMODALITIES = IMODALITIES = {}));
//# sourceMappingURL=modalitie-s.js.map